import { render, staticRenderFns } from "./PaymentMethodListSkeleton.vue?vue&type=template&id=3ae26942"
import script from "./PaymentMethodListSkeleton.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodListSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports